<!-- START-UPSLIDE -->
<div class="container-fluid border-bottom" id="upslide">
    <div class="row ">
        <div class="items-left h5">
            <a href="https://www.tripadvisor.com/Attraction_Review-g297533-d23756180-Reviews-Royal_Galapagos-Puerto_Ayora_Santa_Cruz_Galapagos_Islands.html" class="icon-slide pr-1" target="_blank" title="TripAdvisor"><img src="assets/images/icons/trip-advisor_top.svg" alt="TripAdvisor" height="15" width="23" class="mb-1"></a>
            <a href="https://www.facebook.com/Royal.Galapagos" class=" icon-slide pt-1 pb-1 pr-1 pl-0 text-muted" target="_blank" title="Facebook"><i class="fab fa-facebook" aria-hidden="true"></i></a>
            <a href="https://www.youtube.com/channel/UC2vNT1d5ISslf6qj69LogoA" class="icon-slide p-1 text-muted d-none d-sm-inline" target="_blank" title="YouTube"><i class="fab fa-youtube" aria-hidden="true"></i></a>
            <a href="https://www.instagram.com/royal.galapagos/" class="icon-slide p-1 text-muted" target="_blank" title="Instagram"><i class="fab fa-instagram" aria-hidden="true"></i></a>
            <a href="https://www.linkedin.com/company/royalgalapagos/" class="icon-slide p-1 text-muted d-none d-sm-inline" target="_blank" title="Linkedin"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
        </div>
        <div class="items-right text-right">
            <p class="mb-0 d-inline-block" style="padding-top: 15px;"><i class="fa fa-phone-alt" aria-hidden="true"></i><span class="toll-free"> Toll Free USA: </span><a href="tel:18772097243" title="Call us now">1877-209-7243</a></p>
        </div>
    </div>
</div>
<!-- END-UPSLIDE -->




<!-- Barra de navegación principal-->
<div class="line-white">
    <!--<div class="line">-->
    <div class="nav-modified">
        <a *ngIf="dataCompany" href="https://{{ dataCompany.webSite }}" class="logo-modified">
            <img *ngIf="dataCompany" src="{{companyLogo}}{{ dataCompany.logo }}" width="165" alt="logo" />
        </a>
        <div class="items">
            <div class="items-menu-row">
                <li class="nav-item" *ngFor="let item of menus"><a class="nav-link small" href="{{item.value}}">{{item.name}}</a></li>

            </div>
            <div class="galavail-icon">
                <li class="nav-item-galavail active">
                    <a href="https://galavail.com/" title="GalAvail" class="text-galavail text-right small font-weight-bold" target="_blank"><img src="assets/images/icons/galavail.png" width="20" height="20" alt="GalAvail" class="d-inline-block" style="margin-top:-3px;">
                        <span>
                           Reservation System
                       </span>
                    </a>
                </li>
            </div>
        </div>


        <div class="button-book" *ngIf="companyService.getButtonMenu()">

            <a href="{{companyService.getButtonMenu().value}}" class="booknow-modified " style="font-size: 95%;"><strong>{{companyService.getButtonMenu().name}}</strong></a>
        </div>
    </div>
</div>
<!-- /Barra de navegación principal-->
